import YoutubeModal from './Loader';

export default YoutubeModal;
